import { Store } from "common/data/store.logic";
import { ParamMap } from "@angular/router";
import { FilesNotificationsService } from "files/notifications/filter-role/files-notifications.service";
import UserWithAssignedRoles = stages.process.elements.UserWithAssignedRoles;

export class FileNotificationsStore implements Store<UserWithAssignedRoles> {
	constructor(
		private pageSize: number,
		private filesNotificationService: FilesNotificationsService,
		private isNewFile?: boolean,
	) {}

	async getPage(
		pageIndex: number,
		workspaceId: string,
		pv: string,
		paramMap: ParamMap,
		_queryParamMap?: ParamMap,
	): Promise<SecuredPagedResult<UserWithAssignedRoles>> {
		return this.filesNotificationService.loadUserRoles(
			workspaceId,
			paramMap.get("elementType")!,
			paramMap.get("elementId")!,
			{ page: pageIndex, pageSize: this.pageSize, pv: pv, isNewFile: this.isNewFile },
		);
	}
}
